import { PropsWithChildren } from "react";
import { ChanelCustomContextProvider } from "./chanel/chanel-custom-context-provider";

type CustomContextProviderProps = {
  applicationKey?: string;
};

// アプリIDに応じてカスタムコンテキストを出しわける
export const CustomContextProvider = ({
  applicationKey,
  children,
}: PropsWithChildren<CustomContextProviderProps>) => {
  if (applicationKey === "chanel") {
    return (
      <ChanelCustomContextProvider>{children}</ChanelCustomContextProvider>
    );
  }

  return <>{children}</>;
};
